import type {
  TeaserBaseProps,
  TeaserHighlightProps,
  TeaserMediaProps,
  TeaserThemeProps,
  TeaserVariantProps,
  TeaserVignetteProps,
} from '@bonniernews/dn-design-system-web/assets/types/teaser-props.ts'

import { formatClassString } from '@bonniernews/dn-design-system-web/helpers/formatClassString.ts'
import { Title, Vignette } from '@bonniernews/dn-design-system-web/helpers/teaser.tsx'

import { TeaserCard } from '@bonniernews/dn-design-system-web/components/teaser-card/teaser-card.tsx'

export interface TeaserSwipeCardProps
  extends TeaserBaseProps,
    TeaserThemeProps,
    TeaserHighlightProps,
    TeaserMediaProps,
    TeaserVignetteProps,
    TeaserVariantProps {
  variant?: 'default' | 'insandare' | 'direkt'
  /** The timestamp text of the teaser */
  time?: string
}

/**
 * - GitHub: [BonnierNews/dn-design-system/web/src/components/teaser-swipe-card](https://github.com/BonnierNews/dn-design-system/tree/main/web/src/components/teaser-swipe-card)
 * - Storybook: [TeaserSwipeCard](https://designsystem.dn.se/?path=/docs/section-teaserlistswipe-teaserswipecard--docs)
 *
 * The component will not include styling by itself. Make sure to include the right styles for the component. See example below:
 * `@use '@bonniernews/dn-design-system-web/components/teaser-swipe-card/teaser-swipe-card.scss'`
 */
export const TeaserSwipeCard = ({
  title,
  targetLink,
  highlight,
  theme,
  time,
  media,
  vignette,
  variant,
  classNames,
  attributes,
}: TeaserSwipeCardProps) => {
  const componentClassName = 'ds-teaser-swipe-card'
  const classes = formatClassString([
    'ds-teaser',
    componentClassName,
    variant && variant !== 'default' && `${componentClassName}--${variant}`,
    classNames,
  ])

  return (
    <TeaserCard theme={theme} targetLink={targetLink} classNames={classes} attributes={attributes}>
      {media && variant !== 'direkt' && <div className={'ds-teaser-image'}>{media}</div>}
      <div className='ds-teaser__text'>
        {variant === 'direkt' ? (
          <span className={`${componentClassName}__time`}>{time}</span>
        ) : (
          <Vignette vignette={vignette} variant={variant} />
        )}
        <Title title={title} highlight={highlight} />
        {variant !== 'direkt' && <span className={`${componentClassName}__time`}>{time}</span>}
      </div>
    </TeaserCard>
  )
}
